import BaseModelAPI from '../BaseModelAPI';

export default class JobConfiguration extends BaseModelAPI {
	static entity = 'jobconfiguration';
	static entityName = 'jobconfiguration';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.interfaceName = '';
			this.jobName = '';
			this.jobDescription = '';
			this.isStoredProcedure = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}